/*
 * @Author: Roman
 * @Date: 2022-11-03 09:57:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-07-27 11:24:50
 * @FilePath: \qpmn-site\src\app\modules\basic\header\header-object-tree.service.ts
 * @Description: 
 */

import { IStorageService } from "@core/storage";
import { IProductCatalog } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";
import { PageCacheKey } from "../../basic/page";
import { PageObjectTreeService } from "../../basic/page/page-object-tree.service";
import { IHeaderObjectTreeService } from "./header-object-tree";
import { LocalStorageKeyEnum } from "../LocalStorageKeyEnum";

export class HeaderObjectTreeService extends PageObjectTreeService implements IHeaderObjectTreeService {

    public static readonly $inject: Array<string> = ["storageService"];

    constructor(public storageService: IStorageService<PageCacheKey>) {
        super();
    }

    getFirstName(): string {
        return this.getCache(LocalStorageKeyEnum.FIRST_NAME) || "";
    }

    getCartQty(): string {
        return this.getCache(LocalStorageKeyEnum.CART_NUMBER) || "0";
    }

    clearLogin(): void {
        this.removeCache(LocalStorageKeyEnum.TOKEN);
        this.removeCache(LocalStorageKeyEnum.TOKEN_TYPE);
        this.removeCache(LocalStorageKeyEnum.EXPIRE);
        this.removeCache(LocalStorageKeyEnum.USER_NAME);
        this.removeCache(LocalStorageKeyEnum.FIRST_NAME);
        this.removeCache(LocalStorageKeyEnum.CART_NUMBER);
        this.removeCache(LocalStorageKeyEnum.IS_ANONYMOUS);
        this.removeCache(LocalStorageKeyEnum.PARTNER_TYPE);
        this.removeCache(LocalStorageKeyEnum.STORE_LIST);
        this.removeCache(LocalStorageKeyEnum.STORE_LIST_EXPIRE);

    }
    /**
     * @description
     * @deprecated
     * TODO 临时做法,集成permissionService后去除
     */
    setAnonymous(isAnonymous: boolean, anonymousUserId?: string) {
        this.setCache(LocalStorageKeyEnum.IS_ANONYMOUS, isAnonymous.toString());

        if (anonymousUserId) {
            this.setCache(LocalStorageKeyEnum.ANONYMOUS_USER_ID, anonymousUserId);
        }
    }
}